/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { colors } from "../../theme";

const HorizontalDivider = () => (
    <hr
        css={css`
            border: 0;
            height: 0;
            border-top: 1px solid ${colors.neutral3};
        `}
    />
);

export default HorizontalDivider;
